module.exports = __webpack_public_path__ + "img/Payment-Information.3e5e18c8.gif";